<template>
	<div>
		<loading :active.sync="isLoading" :can-cancel="false" :color="'#e99a60'" :is-full-page="true"></loading>
		<NavBar :showMenu="true" />
		<main role="main">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<form role="form" @submit.prevent="submit">
							<div class="row">
								<div class="col-md-12">
									<h5>Atualize a sua senha</h5>
									<div class="form-group">
										<label>Senha atual</label>
										<input
											type="password"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.oldpassword.$error, 'is-valid': !$v.form.oldpassword.$invalid }"
											v-model.trim="$v.form.oldpassword.$model"
											autocomplete="off"
										/>
										<div class="invalid-feedback" v-if="!$v.form.oldpassword.minLength">
											A senha deve conter no mínimo 8 caracteres.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.oldpassword.required">
											Você deve informar uma senha.
										</div>
									</div>
									<div class="form-group">
										<label>Nova senha</label>
										<input
											type="password"
											:disabled="isLoading"
											class="form-control"
											:class="{ 'is-invalid': $v.form.password.$error, 'is-valid': !$v.form.password.$invalid }"
											v-model.trim="$v.form.password.$model"
											autocomplete="nope"
										/>
										<div class="invalid-feedback" v-if="!$v.form.password.required">A senha é obrigatória.</div>
										<div class="invalid-feedback" v-if="!$v.form.password.minLength">
											A senha deve conter no mínimo 8 caracteres.
										</div>
									</div>
									<div class="form-group">
										<label>Repita a sua nova senha</label>
										<input
											type="password"
											:disabled="isLoading"
											class="form-control"
											:class="{
												'is-invalid': $v.form.repeatPassword.$error,
												'is-valid': !$v.form.repeatPassword.$invalid && $v.form.repeatPassword.$model,
											}"
											v-model.trim="$v.form.repeatPassword.$model"
											autocomplete="nope"
										/>
										<div class="invalid-feedback" v-if="!$v.form.password.repeatPassword">
											As senhas devem ser iguais.
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 text-center">
									<button type="submit" class="btn btn-primary btn-flat" :disabled="isLoading || $v.form.$invalid">
										<span v-if="!isLoading">Atualizar senha</span>
										<span v-if="isLoading">
											<i class="fa fa-circle-o-notch fa-spin"></i>
											Atualizando... aguarde!
										</span>
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Loading from 'vue-loading-overlay';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global';

const axios = require('axios');

/* eslint-disable */
export default {
	name: 'login',
	data: function() {
		return {
			isLoading: false,
			form: {
				oldpassword: '',
				password: '',
				repeatPassword: '',
			}
		};
	},
	components: {
		NavBar,
		Loading,
	},
	validations: {
		form: {
			oldpassword: {
				required,
				minLength: minLength(8),
			},
			password: {
				required,
				minLength: minLength(8),
			},
			repeatPassword: {
				sameAsPassword: sameAs('password'),
			},
		},
	},
	methods: {
		submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isLoading = true;
				axios
					.post(baseApiUrl + 'api/socios/password', { id: this.$auth.user().data.id, data: this.form })
					.then((response) => {
						if (response.data == true) {
							this.$toasted.global.defaultSuccess({
								mensagem: 'Sua senha foi atualizada com sucesso!',
							});
							this.$router.push('/home');
						} else {
							this.$toasted.global.defaultError({
								mensagem: 'Não foi possível atualizar a sua senha. Verifique a sua senha atual e tente novamente.',
							});
						}
					})
					.catch(() => {
						this.$toasted.global.defaultError({
							mensagem: 'Não foi possível atualizar a sua senha. Tente novamente mais tarde.',
						});
					})
					.finally(() => {
						this.isLoading = false;
					});
			}
		},
	}
};
</script>
